import { useQuery } from '@tanstack/react-query';
import { nexusFetch } from '../../nexus/nexusClient';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';

/**
 * Produkt-Statistik Base (BaaS) — Betreiber-Sicht, nur lesend. Aggregat über
 * alle Base-Projekte: wie viele existieren, wie viele haben eine provisionierte
 * DB, plus Tenant-/Bucket-/Function-Zähler und Aufschlüsselung nach Plan/Region.
 * M2M-Auth wie alle /v1/admin/*-Endpoints.
 */
const FIXTURE = {
  projects: 128,
  provisioned: 97,
  tenants: 114,
  buckets: 342,
  functions: 511,
  byPlan: [
    { plan: 'free', n: 71 },
    { plan: 'pro', n: 44 },
    { plan: 'enterprise', n: 13 },
  ],
  byRegion: [
    { region: 'fsn1', n: 88 },
    { region: 'nbg1', n: 31 },
    { region: 'hel1', n: 9 },
  ],
};

export function useBaseStats() {
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['product-stats-base', fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) { await fixtureDelay(); return FIXTURE; }
      return nexusFetch('/v1/admin/product-stats/base');
    },
    refetchInterval: 60_000,
  });
}
